import React from "react";

type FeatureClickTooltipProps = {
  visible: boolean;
  properties: any;
  onClose: () => void;
  onOpenDetail?: (planningId: any) => void;
};

export default function FeatureClickTooltip(props: FeatureClickTooltipProps) {
  const { visible, properties, onClose, onOpenDetail } = props;

  if (!visible || !properties) return null;
  const planningId = (properties && (properties.planningId ?? properties.id)) as any;

  return (
    <div
      className="feature-click-tooltip"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="feature-click-tooltip__header">
        <div className="feature-click-tooltip__title">
          {String(properties.tooltipValue ?? properties.name ?? "Thông tin")}
        </div>
        <button className="feature-click-tooltip__close" onClick={onClose}>
          ×
        </button>
      </div>

      <div className="feature-click-tooltip__body">
        <div className="feature-click-tooltip__row">
          <div className="feature-click-tooltip__key">Địa chỉ</div>
          <div className="feature-click-tooltip__value">{properties.address || "-"}</div>
        </div>
        <div className="feature-click-tooltip__row">
          <div className="feature-click-tooltip__key">Diện tích</div>
          <div className="feature-click-tooltip__value">{properties.area ? properties.area + ' ha' : "-"}</div>
        </div>
        <div className="feature-click-tooltip__row">
          <div className="feature-click-tooltip__key">Tỷ lệ lấp đầy</div>
          <div className="feature-click-tooltip__value">{properties.percentage ? properties.percentage + '%' : "-"}</div>
        </div>
        <div className="feature-click-tooltip__row">
          <div className="feature-click-tooltip__key">Chủ đầu tư</div>
          <div className="feature-click-tooltip__value">{properties.investor || "-"}</div>
        </div>
        <div className="feature-click-tooltip__row">
          <div className="feature-click-tooltip__key">Ghi chú</div>
          <div className="feature-click-tooltip__value">{properties.note || "-"}</div>
        </div>
      </div>

      {planningId !== undefined && planningId !== null && onOpenDetail ? (
        <div className="feature-click-tooltip__footer">
          <button
            className="feature-click-tooltip__detail"
            onClick={() => onOpenDetail(planningId)}
          >
            Xem chi tiết
          </button>
        </div>
      ) : null}
    </div>
  );
}
